"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StatesSelect = void 0;
var _objectSpread2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var _SearchSelect = require("../search-select/SearchSelect");
var _react = _interopRequireDefault(require("react"));
var _useStatesOptions = require("./hooks/useStatesOptions");
var StatesSelect = function StatesSelect(props) {
  var statesOptions = (0, _useStatesOptions.useStatesOptions)();
  var selectProps = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, props), {}, {
    options: statesOptions
  });
  return /*#__PURE__*/_react.default.createElement(_SearchSelect.SearchSelect, selectProps);
};
exports.StatesSelect = StatesSelect;